import {
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { useStyles } from "./styles";
import InsertFuncionalitiesModal from "./AddFuncionalitiesInstitute";
import { useNavigate } from "react-router-dom";
import Loader, { TableLoader } from "../../../common/Loader";
import CustomPagination from "../../../common/Pagination";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useState } from "react";
import { useCallback } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import useSuperAdminConfiguration from "../../../Hooks/configuration";
const label = { inputProps: { "aria-label": "Enabled" } };

const columns = [
  // {
  //   id: "S.No",
  //   label: "S.No",
  //   align: "center",
  //   sortby: true,
  // },
  {
    id: "name",
    sortby: true,
    label: "Name",
    align: "center",
  },
  {
    id: "emailId",
    sortby: true,
    label: "Email Id",
    align: "center",
  },
  {
    id: "status",
    sortby: true,
    label: "Status",
    align: "center",
  },
];
const isEmptyObject = (obj) => {
  try {
    return Object.keys(obj).length === 0;
  } catch (error) {
    return true;
  }
};

const findFunctionalityById = (data, id) => data?.find((_) => _.id === id);
function TableRows(props) {
  const { value, index, offset } = props;
  const [open, setOpen] = React.useState(false);
  const { allfunctionalitiesData, updateFunctionalitiesAction } =
    useSuperAdminConfiguration();

  const _el = value[0];
  return (
    <React.Fragment key={index}>
      <TableRow tabIndex={-1} key={index}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {columns.map((column) => {
          return (
            <TableCell key={column.id} align={column.align}>
              {column.id === "S.No" ? (
                <Stack sx={{ alignItems: "center" }}>
                  <span>{offset + index + 1}</span>
                  {/* <Checkbox defaultChecked /> */}
                </Stack>
              ) : column.id === "name" ? (
                _el.institutionName
              ) : column.id === "emailId" ? (
                _el.emailId
              ) : (
                <Stack>-</Stack>
              )}
            </TableCell>
          );
        })}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0 }}>
              {/* <Typography variant="body1" gutterBottom component="div">
                Functions
              </Typography> */}
              <Grid container>
                {value?.map((_item, i) => {
                  return (
                    <Grid
                      sm={4}
                      key={i}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        alignContent: "center",
                      }}
                    >
                      <Typography
                        variant="caption"
                        gutterBottom
                        component="div"
                      >
                        {
                          findFunctionalityById(
                            allfunctionalitiesData,
                            _item.idFunctionalities
                          )?.name
                        }
                      </Typography>

                      <Switch
                        onChange={(e) => {
                          console.log(
                            "onChange",
                            e.target.name,
                            e.target.checked
                          );

                          updateFunctionalitiesAction({
                            id: _item.id,
                            idInstitution: _item.idInstitution,
                            idFunctionalities: _item.idFunctionalities,
                            enabled: e.target.checked,
                          });
                        }}
                        {...label}
                        color="success"
                        name={_item.idFunctionalities}
                        defaultChecked={_item.enabled}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
// const Body = ({ data, offset }) => {
//   return (
//     <>
//       {!isEmptyObject(data) ? (
//         Object.entries(data).map(([key, value], index) => {
//           return (
//             <TableRows
//               value={value}
//               offset={offset}
//               tabIndex={-1}
//               index={index}
//               key={index}
//             ></TableRows>
//           );
//         })
//       ) : (
//         <TableRow>
//           <TableCell colSpan={6} sx={{ borderBottom: "none" }}>
//             <Stack
//               sx={{
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               No Data
//             </Stack>
//           </TableCell>
//         </TableRow>
//       )}
//     </>
//   );
// };

const Configuration = () => {

  const {
    loading,
    getAllFunctionalitiesAction,
    getAllSuperAdminConfigurationsAction,
    superAdminConfigurationsData,
    superAdminConfigurationsTotalNoOfRecords,
    superAdminConfigurationsLoading,
    allfunctionalitiesData,
    geAllInstitutionsAction,
    updateFunctionalitiesAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
  } = useSuperAdminConfiguration();

  const classes = useStyles();
  const [functionalities, setFunctionalities] = useState(allfunctionalitiesData === null ? "" : allfunctionalitiesData[0]?.id)
  const [open, setOpen] = useState(false);
  // const [page, setPage] = useState(1);
  // const [PerPage, setPerPage] = useState(10);
  // const [offset, setOffset] = useState(0);

  // console.log("loading",superAdminConfigurationsData,"functionalities",functionalities)
  // const {
  //   institutionsData,
  //   allfunctionalitiesData,
  //   insertFuncionalitiesAction,
  // } = useSuperAdminConfiguration();

  const navigate = useNavigate();

  const handlePage = (e) => {
    // setPerPage(e.target.value);
    // setPage(1);
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };

  React.useLayoutEffect(() => {
    getAllFunctionalitiesAction({});
    geAllInstitutionsAction({});
  }, []);

  React.useEffect(() => {
    getAllSuperAdminConfigurationsAction({
      limit: perPage,
      offset: offset,
      idFunctionalities: functionalities,
    });
  }, [perPage, offset,functionalities]);

  const handleFunctialitiesChanges =(value)=>{
    setFunctionalities(value);
    // setPage(1);
    // setOffset(0);
    // setPerPage(10);
    setOffsetAction(0)
    setPageAction(1)
    // setPerPageAction(10)
  }

  const count =
    Math.ceil(superAdminConfigurationsTotalNoOfRecords / perPage) || 0;

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * PerPage - PerPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
    },
    [perPage]
  );

  return (
    <Stack className={classes.arrival}>
      {superAdminConfigurationsLoading && (
        <div>
          <Loader />
        </div>
      )}
      <Grid container>
        <Grid item lg={10} xl={10} sm={12}>
          <Stack sx={{ marginTop: "20px" }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",

                  overflowY: "auto",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <TableContainer sx={{}}>
                    <Typography
                      variant="h5"
                      gutterBottom
                      component="div"
                      // textTransform={"uppercase"}
                      fontWeight={"500"}
                    >
                      Configuration
                    </Typography>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        py: 2,
                      }}>
                      <Select
                        value={functionalities}
                        onChange={(event)=>handleFunctialitiesChanges(event.target.value)}
                        // onChange={(event) => setFunctionalities(event.target.value)}
                        IconComponent={CustomExpandMore}
                        sx={{
                          width: 200,
                          marginLeft: "0px !important",
                          borderRadius: "50px",
                        }}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          <span>Select Functionalities</span>
                        </MenuItem>
                        {allfunctionalitiesData && allfunctionalitiesData?.map((_el, index) => (
                          <MenuItem value={_el.id} key={index}>
                            {_el.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {/* </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        py: 2,
                      }}
                      className={classes.add_new_config_container}
                    > */}
                      <Button
                        type="submit"
                        sx={{ px: 1, py: 1, borderRadius: "50px" }}
                        className={classes.add_new_config}
                        onClick={() => {
                          setOpen(true);
                        }}
                      >
                        Add Functionalities
                      </Button>
                    </Stack>
                    {loading ? (
                      <div>
                        {" "}
                        <TableLoader />
                      </div>
                    ) : (
                      <Table
                        aria-label="sticky table"
                        className={classes.root}
                        style={{ padding: 0 }}
                      >
                        <TableHead style={{ position: "sticky", top: 0 }}>
                          <TableRow classes={{ root: classes.thead }}>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody classes={{ root: classes.tBody }}>
                          {superAdminConfigurationsData && superAdminConfigurationsData?.length > 0 ? (
                            superAdminConfigurationsData?.map((_el, index) => (
                              <TableRow tabIndex={-1} key={index}>
                                {columns.map((column) => {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "name" ? (
                                        _el.institutionName
                                      ) : column.id === "emailId" ? (
                                        _el.emailId
                                      ) : column.id === "status" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <Switch
                                            onChange={(e) => {
                                              updateFunctionalitiesAction({
                                                id: _el.id,
                                                idInstitution: _el.idInstitution,
                                                idFunctionalities: _el.idFunctionalities,
                                                enabled: e.target.checked,
                                              });
                                            }}
                                            {...label}
                                            color="success"
                                            name={_el.idFunctionalities}
                                            defaultChecked={_el.enabled}
                                          />
                                        </Stack>
                                      ) : ("")
                                      }
                                    </TableCell>)
                                })}
                              </TableRow>))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={3}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data
                                </Stack>
                              </TableCell>
                            </TableRow>)}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                  
                  { !loading && (
                      superAdminConfigurationsTotalNoOfRecords > 10 && (
                        <CustomPagination
                          count={count}
                          page={page}
                          onPageChange={handleChange}
                          handlePage={handlePage}
                          perPage={perPage}
                        // hidePerPage={true}
                        />
                      ))
                }
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={4} sm={12}></Grid>
      </Grid>
      <InsertFuncionalitiesModal
        setOpen={setOpen}
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
      />
    </Stack>
  );
};

export default Configuration;
